import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/useAuthStore';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, isCheckingAuth } = useAuthStore();
  const location = useLocation();

  if (isCheckingAuth) {
    return (
      <div className="min-h-screen bg-seryi-bg-dark flex flex-col justify-center items-center p-4">
        <img src="/icono-seryiads.png" alt="Keyla CRM" className="w-20 h-20 mb-4 animate-pulse drop-shadow-lg" />
        <h1 className="font-black text-3xl text-seryi-heading tracking-tight mb-1">Keyla CRM</h1>
        <p className="text-seryi-text text-sm font-bold tracking-widest uppercase animate-pulse">Cargando Sistema...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirigir al login si no está autenticado, guardando la ruta intentada
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
